module.exports = __webpack_public_path__ + "img/west-alabama-university-logo.42bf5c82.jpg";